var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('student-drawer',[_c('v-col',{attrs:{"xl":"12","lg":"12","md":"12","sm":"12","xs":"12","align":"center"}},[[_c('router-view')]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }